The identifier for the `HiringOrganization` used to provide location suggestions weighted by the hirer's SEEK-configured domicile.
